// extracted by mini-css-extract-plugin
module.exports = {"accountInfo":"q","dropdownContent":"r","prime":"s","heading":"t","rewardsMember":"u","vipDashboard":"v","primeBadge":"w","close":"x","rewardsAmount":"y"};